<template>
  <v-dialog :value="value" width="640px" persistent>
    <v-card class="pa-0">
      <v-card-title>Remove days</v-card-title>
      <v-card-text class="black--text">
        <p class="mb-4">
          You are reducing this quote by {{ daysToRemove }} day{{ daysToRemove > 1 ? "s" : "" }}. Select which
          day{{ daysToRemove > 1 ? "s" : "" }} to remove:
        </p>

        <div class="remove-days-list">
          <v-checkbox
            v-for="day in dayOptions"
            :key="day.index"
            v-model="selectedIndexes"
            :value="day.index"
            :label="day.label"
            hide-details
            class="mt-0 pt-1"
          />
        </div>

        <div class="caption mt-3" :class="{ 'error--text': !isSelectionValid && selectedIndexes.length > 0 }">
          Select exactly {{ daysToRemove }} day{{ daysToRemove > 1 ? "s" : "" }}.
          <span v-if="selectedIndexes.length !== daysToRemove">
            ({{ selectedIndexes.length }} selected)
          </span>
        </div>
      </v-card-text>

      <v-card-actions>
        <g-button label="Cancel" @onclick="onCancel" />
        <div class="flex-grow-1"></div>
        <g-button label="Remove" type="primary" :disabled="!isSelectionValid" @onclick="onConfirm" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    days: {
      type: Array,
      default: () => [],
    },
    daysToRemove: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      selectedIndexes: [],
    };
  },
  computed: {
    dayOptions() {
      return (this.days || []).map((day, index) => ({
        index,
        label: day.label || `Day ${index + 1}`,
      }));
    },
    isSelectionValid() {
      return this.selectedIndexes.length === Number(this.daysToRemove);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(isOpen) {
        if (!isOpen) return;
        this.selectedIndexes = this.getDefaultSelectedIndexes();
      },
    },
    daysToRemove() {
      if (this.value) {
        this.selectedIndexes = this.getDefaultSelectedIndexes();
      }
    },
  },
  methods: {
    getDefaultSelectedIndexes() {
      const total = this.dayOptions.length;
      const count = Math.max(0, Number(this.daysToRemove) || 0);
      const start = Math.max(0, total - count);
      const selected = [];
      for (let i = start; i < total; i += 1) {
        selected.push(i);
      }
      return selected;
    },
    onCancel() {
      this.$emit("input", false);
      this.$emit("cancel");
    },
    onConfirm() {
      if (!this.isSelectionValid) return;
      this.$emit("input", false);
      this.$emit("confirm", [...this.selectedIndexes].sort((a, b) => a - b));
    },
  },
};
</script>

<style scoped>
.remove-days-list {
  max-height: 360px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px 12px;
}
</style>
